const React = require("react");
require("@fontsource/poppins/100.css");
require("@fontsource/poppins/100-italic.css");
require("@fontsource/poppins/200.css");
require("@fontsource/poppins/200-italic.css");
require("@fontsource/poppins/300.css");
require("@fontsource/poppins/300-italic.css");
require("@fontsource/poppins/400.css");
require("@fontsource/poppins/400-italic.css");
require("@fontsource/poppins/500.css");
require("@fontsource/poppins/500-italic.css");
require("@fontsource/poppins/600.css");
require("@fontsource/poppins/600-italic.css");
require("@fontsource/poppins/700.css");
require("@fontsource/poppins/700-italic.css");
require("@fontsource/poppins/800.css");
require("@fontsource/poppins/800-italic.css");
require("@fontsource/poppins/900.css");
require("@fontsource/poppins/900-italic.css");
require("./src/styles/global.css");

const { ThemeProvider } = require("./src/theme/ThemeContext");

exports.wrapRootElement = ({ element }) => {
  return React.createElement(ThemeProvider, null, element);
};
